import { useState } from "react";
import { PANEL, TEAL, CREAM, CREAM60, BORDER, riskColor, riskLabel, fmt, fmtWage } from "../utils/constants";

function JobCard({ job, onClick }) {
  const [hov, setHov] = useState(false);
  const c = riskColor(job.score);
  return (
    <div onClick={onClick} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{ background: hov ? "rgba(14,30,48,0.95)" : PANEL, border: `1px solid ${hov ? TEAL : BORDER}`, borderTop: `2px solid ${c}`, borderRadius: 12, padding: 16, cursor: "pointer", transition: "all 0.2s", transform: hov ? "translateY(-2px)" : "none" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
        <div style={{ fontSize: 15, fontWeight: 600, color: CREAM, lineHeight: 1.3, fontFamily: "'Space Grotesk', sans-serif", flex: 1, marginRight: 8 }}>{job.title}</div>
        <div style={{ fontSize: 22, fontWeight: 700, color: c, fontFamily: "'JetBrains Mono', monospace", whiteSpace: "nowrap" }}>{job.score}</div>
      </div>
      <div style={{ display: "flex", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
        <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 4, background: `${c}20`, color: c, fontWeight: 600 }}>{riskLabel(job.score)} Risk</span>
        <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 4, background: `${TEAL}15`, color: TEAL }}>{job.industry}</span>
      </div>
      <div style={{ height: 4, borderRadius: 2, background: `${CREAM}10`, marginBottom: 10, overflow: "hidden" }}>
        <div style={{ height: "100%", width: `${job.score * 10}%`, background: `linear-gradient(90deg, ${c}80, ${c})`, borderRadius: 2 }} />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: CREAM60, fontFamily: "'JetBrains Mono', monospace" }}>
        <span>{fmt(job.employed)} employed</span><span>{fmtWage(job.wage)}</span>
      </div>
    </div>
  );
}

export default JobCard;
